import React from "react";
import { Link } from "react-router-dom";
import { FaPhone, FaEnvelope } from "react-icons/fa";
import "./HandbookContactCtaSection.css";
import "../../HowItWorks/CallToActionSection/CallToActionSection.css"
const HandbookContactCtaSection = () => {
  return (
    <section className="_hCCSect_y1A_ _cTASectCont_x1A_" style={{marginTop:"0rem"}}>
      <div className="_cTASectContent_y2B_">
        <h2 className="_hTitle_s5E_ features-title" style={{marginBottomBottom:"20rem"}}>Questions? Contact Support</h2>

        <div className="_contact_group_v2A_">
          <div className="_contact_item_w3B_" >
            <FaPhone className="_cIcon_c5C_" /> Call &nbsp;
            <span className="_bold_contact_text_1Y_">+91 99999 99999</span>
          </div>

          <div className="_contact_item_w3B_" style={{marginBottom:"0", paddingBottom:"0"}}>
            <FaEnvelope className="_cIcon_c5C_" /> Email&nbsp;
            <span className="_bold_contact_text_1Y_">support@vanidya.com</span>
          </div>
        </div>

        <p className="_cDesc_b4C_" style={{marginTop:"0", paddingTop:"0"}}>
          For more, read the &nbsp;
          <Link to="/faq" className="_cLink_d6C_">
            FAQ,
          </Link>
      &nbsp;
          <Link to="/sop" className="_cLink_d6C_">
            SOP,
          </Link>
          &nbsp;
           or our&nbsp;
          <Link to="/support" className="_cLink_d6C_">
            Support Center
          </Link>
          .
        </p>
      </div>
    </section>
  );
};

export default HandbookContactCtaSection;
